const getVariantIdCollection = (products, productsWithVariants) => {
  if (!products?.length || !productsWithVariants?.length) return [];
  const arrayOfVariantIdStrings = [];
  products.forEach((productItem) => {
    const matchedProduct = productsWithVariants.find(
      (productWithVariantIdItem) => {
        return (
          productItem.productId === productWithVariantIdItem.id &&
          productWithVariantIdItem?.variants?.[0] &&
          Boolean(productWithVariantIdItem.isAvailable)
        );
      }
    );

    if (matchedProduct?.variants?.[0]?.id) {
      arrayOfVariantIdStrings.push(matchedProduct.variants[0].id);
    }
  });

  return [...new Set(arrayOfVariantIdStrings)];
};

export default getVariantIdCollection;
